import { defineStore } from 'pinia'
import { reactive } from 'vue'
import type { RecentListItem } from '../utils/recent-values-types'

/**
 * Shared reactive recent-value lists keyed by caller id (e.g. localStorage key).
 * Persistence is handled outside the store (see `useRecentValues`).
 */
export const useRecentValuesStore = defineStore('gpx-ui-recent-values', () => {
  const lists = reactive<Record<string, RecentListItem[]>>({})

  function getList(key: string): RecentListItem[] {
    if (!key) return []
    if (!lists[key]) lists[key] = []
    return lists[key]
  }

  function replaceList(key: string, next: RecentListItem[]): void {
    if (!key) return
    const arr = getList(key)
    arr.splice(0, arr.length, ...next)
  }

  return {
    lists,
    getList,
    replaceList,
  }
})
